import { Icon, IconDefinitions, TitlelessCard } from "../../../../components";

interface NoActiveStreamCardProps {
  startError: boolean;
}

export function NoActiveStreamCard({ startError }: NoActiveStreamCardProps) {
  return (
    <TitlelessCard>
      <div className="d-flex flex-column align-items-center justify-content-center py-4">
        <Icon
          iconName={IconDefinitions.chartLine}
          className="text-muted mb-2"
          style={{ fontSize: "1.5rem" }}
        />
        <h6 className="text-muted fw-semibold mb-1">No Active Inspection Stream</h6>
        <p
          className="text-muted small mb-0"
          style={{ maxWidth: 300, textAlign: "center" }}
        >
          {startError
            ? "Failed to start the live view session. The device may not have an active inspection file."
            : "No inspection files are being actively written to. A stream will appear here when the device begins writing inspection data."}
        </p>
      </div>
    </TitlelessCard>
  );
}